import { differenceDate } from '@ajaibid/utils';
import { formKey } from '@context/stock/buysell/constants';

export const getAdditionalComponents = ({ stockAbout, isMarketOpen }) => {
  const specialNotations = stockAbout?.special_notations?.map((v) => v?.description) || [];
  const isOnAcceleratedBoard = stockAbout?.is_accelerated_board_member ? 'Accelerated Board' : null;
  const _isMarketOpen = isMarketOpen ? 'Market Open' : 'Market Closed';

  return [_isMarketOpen, isOnAcceleratedBoard, ...specialNotations].filter(Boolean).join(', ');
};

export const getAtoDuration = (formState) => {
  if (!formState?.[formKey.INPUT_START_DATE] || !formState?.[formKey.INPUT_END_DATE]) {
    return null;
  }
  const startDate = new Date(formState?.[formKey.INPUT_START_DATE]);
  const endDate = new Date(formState?.[formKey.INPUT_END_DATE]);

  return differenceDate(startDate, endDate, 'day', false);
};

export const getAtoTriggerPrice = (formState) => {
  const comparator = formState[formKey.INPUT_THRESHOLD_COMPARATOR]?.label;
  const price = formState[formKey.INPUT_THRESHOLD_VALUE];

  if (!comparator || !price) {
    return null;
  }

  return `${comparator} ${price}`;
};
